<template>
    <div class="position-box">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title">{{ $t('my.as') }}</div>
        </div>
        <div class="cotainer">
            <ul class="ul-box" v-if="lang == 'ar'">
                <router-link class="li" tag="li" to="/securityCenter">
                    <img class="arrow" v-if="theme" src="@/assets/theme/icon_back.png" alt="">
                    <img class="arrow" v-else src="@/assets/alb/icon_back.png" alt="">
                    <div class="text">{{ $t('safe.center') }}</div>
                </router-link>
                <router-link class="li" tag="li" to="/language">
                    <img class="arrow" v-if="theme" src="@/assets/theme/icon_back.png" alt="">
                    <img class="arrow" v-else src="@/assets/alb/icon_back.png" alt="">
                    <div class="text">{{ $t('safe.yysz') }}</div>
                </router-link>
                <li class="li">
                    <!-- 浅色 -->
                    <img class="arrow mode" v-show="!theme" src="@/assets/Dark-switch.png" @click="change" alt="">
                    <!-- 深色 -->
                    <img class="arrow mode" v-show="theme" src="@/assets/Dark-switch2.png" @click="change" alt="">
                    <div class="text">{{ $t('safe.ssms') }}</div>
                </li>
                <router-link class="li" tag="li" to="/about">
                    <img class="arrow" v-if="theme" src="@/assets/theme/icon_back.png" alt="">
                    <img class="arrow" v-else src="@/assets/alb/icon_back.png" alt="">
                    <div class="text">{{ $t('safe.gywm') }}</div>
                </router-link>

                <li class="li" @click="createClick">
                    <div class="text">{{ $t('my.mnzh') }}</div>
                    <img class="arrow" v-if="theme" src="@/assets/theme/jiantou_white.png" alt="">
                    <img class="arrow" v-else src="@/assets/user/jiantou.png" alt="">
                </li>
            </ul>
            <ul class="ul-box" v-else>
                <router-link class="li" tag="li" to="/securityCenter">
                    <div class="text">{{ $t('safe.center') }}</div>
                    <img class="arrow" v-if="theme" src="@/assets/theme/jiantou_white.png" alt="">
                    <img class="arrow" v-else src="@/assets/user/jiantou.png" alt="">
                </router-link>
                <router-link class="li" tag="li" to="/language">
                    <div class="text">{{ $t('safe.yysz') }}</div>
                    <img class="arrow" v-if="theme" src="@/assets/theme/jiantou_white.png" alt="">
                    <img class="arrow" v-else src="@/assets/user/jiantou.png" alt="">
                </router-link>
                <li class="li">
                    <div class="text">{{ $t('safe.ssms') }}</div>
                    <!-- 浅色 -->
                    <img class="arrow mode" v-show="!theme" src="@/assets/Dark-switch.png" @click="change" alt="">
                    <!-- 深色 -->
                    <img class="arrow mode" v-show="theme" src="@/assets/Dark-switch2.png" @click="change" alt="">
                </li>
                <router-link class="li" tag="li" to="/about">
                    <div class="text">{{ $t('safe.gywm') }}</div>
                    <img class="arrow" v-if="theme" src="@/assets/theme/jiantou_white.png" alt="">
                    <img class="arrow" v-else src="@/assets/user/jiantou.png" alt="">
                </router-link>
                <li class="li" @click="createClick">

                    <div class="text">{{ $t('my.mnzh') }}</div>
                    <img class="arrow" v-if="theme" src="@/assets/theme/jiantou_white.png" alt="">
                    <img class="arrow" v-else src="@/assets/user/jiantou.png" alt="">
                </li>
            </ul>
            <button class="btn-login btn-bg" @click="loginOut">{{ $t('index.logout') }}</button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'set',
    data() {
        return {
            theme: false,
            lang: 'en'
        }
    },
    created() {
        this.theme = JSON.parse(localStorage.getItem('theme'));
        this.lang = localStorage.getItem('language') || 'en';
    },
    mounted() {
        $("input").keyup(function () {	//去掉空格
            $(this).val($(this).val().replace(/[, ]/g, ''));
        });
    },
    methods: {
        back() {
            this.$router.push('/user')
        },
        change() {
            this.theme = !this.theme;
            localStorage.setItem('theme', this.theme);
            this.themeChange();
        },
        createClick() {

            this.$ajax.get('/web/tempLogin').then((res) => {
                console.log(res, 151221);
                let resData = res.data;
                if (resData.code == 0 || resData.code == 4 || resData.code == 7) {
                    localStorage.setItem('token', resData.data.token);
                    localStorage.removeItem('sbsxbz');
                    localStorage.removeItem('sbsxIcon');
                    this.$toast.center(this.$t("my.mnzhcg"));
                    setTimeout(() => {
                        this.$router.push('/index')
                    }, 1000)
                } else {
                    this.$toast.center(resData.message);
                    return;
                }
                // let resData = res.data;
                // if (resData.code == 0 || resData.code == 4 || resData.code == 7) {
                //     localStorage.setItem('token', resData.data.token);
                //     localStorage.removeItem('sbsxbz');
                //     localStorage.removeItem('sbsxIcon');
                //     setTimeout(() => {
                //         this.$router.push('/index')
                //     }, 1000)
                // } else {
                //     this.$toast.center(resData.message);
                //     return;
                // }
            }).catch(function (err) {
                console.log(err)
            })
        },
        themeChange() {
            // 网站主题
            var css;
            var theme = JSON.parse(localStorage.getItem('theme'));
            css = document.createElement('link');
            css.id = 'themestyle',
                css.type = 'text/css';
            css.rel = 'stylesheet';
            var headNode = document.getElementsByTagName("head")[0];
            headNode.appendChild(css);
            if (theme) {
                $('#themestyle').attr('href', '/static/css/theme.css');
            } else {
                $('#themestyle').attr('href', '');
            }
        },
        loginOut() {
            localStorage.removeItem('token');
            localStorage.removeItem('area_code');
            localStorage.removeItem('city_code');
            localStorage.removeItem('bz');
            localStorage.removeItem('type');
            localStorage.removeItem('tim');
            localStorage.removeItem('type');
            localStorage.removeItem('sbsxbz');
            localStorage.removeItem('sbsxIcon');
            this.$router.push('/login')
        }
    }
}
</script>
<style scoped>
.head {
    position: fixed;
    top: 0;
    width: 100%;
    height: 1.6rem;
    padding: 0 .44rem;
    color: #000;
    line-height: 1.6rem;
    background: #fff;
    box-sizing: border-box;
    text-align: center;
}

.head .back {
    position: absolute;
    left: .4rem;
    top: 50%;
    width: .5rem;
    margin-top: -.4rem;
}

.head .title {
    font-size: .56rem;
}

.head .text {
    font-size: .48rem;
}

.cotainer {
    position: absolute;
    top: 1.6rem;
    bottom: 0;
    width: 100%;
    background: #f9f9f9;
    overflow-y: scroll;
}

.cotainer .ul-box .li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: .3rem;
    padding: .6rem .45rem;
    color: #000;
    font-size: .42rem;
    background: #fff;
}

.cotainer .ul-box .li .arrow {
    width: .24rem;
}

.cotainer .ul-box .li .arrow.mode {
    width: 1.2rem;
}

.cotainer .ul-box .li:last-child {
    border-bottom: none;
}

.cotainer .btn-login {
    position: fixed;
    left: 50%;
    bottom: .48rem;
    width: 9rem;
    transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/pages/set.vue